module.exports = __webpack_public_path__ + "img/a3.c4a79d6f.jpg";